module.exports = __webpack_public_path__ + "static/media/video-coming-soon_1707730477090.59d3a2c1.gif";